import { priceFields } from '../../config/endpoint-fields/price.fields';

export const productPriceStockFields = [
  ...priceFields,
  'stock(FULL)'
];
